import { useState } from 'react'
import type { MemberDetail, RevealedProfileFields, SensitiveProfileField } from '@workflow/contracts'
import { useRevealMemberFields } from '@/lib/api/hooks'
import { ProfileGroups } from './profileView'

/**
 * What a review is of: the profile as submitted, one group at a time in the
 * order the form asked for it. The dates of the record — whitelisted when,
 * last seen when — are the Activity page's story, not the person's; here
 * only the person is. Shared by the requests queue and the directory — the
 * same person is rendered once, wherever an administrator meets them. For a
 * player this profile IS the player record; the Discord group is how the
 * outside world knows them.
 *
 * The record arrives masked, and each sensitive field passes the mask one
 * audited reveal at a time: what is asked for is held here, in the view of
 * the one who asked, until the panel closes.
 */
export function ProfileReview({ member }: { member: MemberDetail }) {
  const [revealed, setRevealed] = useState<RevealedProfileFields>({})
  const reveal = useRevealMemberFields()

  const ask = (field: SensitiveProfileField) => {
    reveal.mutate(
      { id: member.id, fields: [field] },
      { onSuccess: (answer) => setRevealed((current) => ({ ...current, ...answer })) },
    )
  }

  return (
    <ProfileGroups
      profile={member.profile ? { ...member.profile, ...revealed } : null}
      mask={{ revealed: new Set(Object.keys(revealed) as SensitiveProfileField[]), onReveal: ask }}
    />
  )
}
